// Libs
import React from 'react';
import { Collapse, Icon, Input, Tooltip } from 'antd';

// Own Libs
import { Button, Widget } from '@digital/ui';

//Api

//Files
import { IMinuta } from '@app/models/MinutaModels';
import { InputLabel } from '@app/components';

//Utils


interface IInputDescricao {
  value: string;
  onChange: (value: string) => void;
}

interface Props {
  minuta: IMinuta;
  readonly?: boolean;
  inputDescricao?: IInputDescricao;
  actions: React.ReactNode[]
}

const MinutaCabecalho: React.FC<Props> = ({ minuta, inputDescricao, actions }) => {
  return (
    minuta && (
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />} defaultActiveKey={['customizada']}>
        <Collapse.Panel key="customizada" header="Preenchimento da minuta">
          <Widget
            actions={actions}
          >
            <InputLabel label="Número da demanda" span={3}>
              <Input name="numeroDaDemanda" value={minuta.demanda && minuta.demanda.identificadorTexto} />
            </InputLabel>

            <InputLabel label="Descrição da minuta" span={6}>
              {inputDescricao ? (
                <Input
                  name="descricaoDaMinuta"
                  onChange={e => {
                    inputDescricao.onChange(e.target.value);
                  }}
                  value={inputDescricao.value}
                />
              ) : (
                <Input name="descricaoDaMinuta" value={minuta.descricao} readOnly={true} />
              )}
            </InputLabel>

            <InputLabel label="Tipo da minuta" span={3}>
              <Input name="respostaTipoDaMinuta" value={minuta.respostaTipoDaMinuta && minuta.respostaTipoDaMinuta.nome} readOnly={true} />
            </InputLabel>

            {minuta.diretoria && minuta.diretoria.nome && (
              <InputLabel label="Diretoria" span={3}>
                <Input name="diretoria" value={minuta.diretoria.nome} readOnly={true} />
              </InputLabel>
            )}

            {minuta.area && minuta.area.nome && (
              <InputLabel label="Área Solicitante" span={3}>
                <Input name="inputAreaSolicitante" value={minuta.area.nome} readOnly={true} />
              </InputLabel>
            )}

            {minuta.departamento && minuta.departamento.nome && (
              <InputLabel label="Departamento" span={3}>
                <Input name="departamento" value={minuta.departamento.nome} readOnly={true} />
              </InputLabel>
            )}

            <InputLabel label="Status da minuta" span={3}>
              <Input name="statusMinuta" value={minuta.statusMinuta && minuta.statusMinuta.nome} readOnly={true} />
            </InputLabel>


          </Widget>
        </Collapse.Panel>
      </Collapse>
    )
  );
};

export default MinutaCabecalho;
